import { graphql } from '@/graphql-setup'

/* ABSENCES*/

export const EXPORT_ABSENCES_MASS = graphql(`
  mutation ExportAbsencesMass(
    $userId: ID!
    $users: [ID]!
    $companyId: ID!
    $dateStart: String!
    $dateEnd: String!
    $exportType: String!
    $exportFormat: ExportFormat
    $orderBy: String
    $exportOption: ExportOption
  ) {
    exportAbsencesMass(
      userId: $userId
      users: $users
      companyId: $companyId
      dateStart: $dateStart
      dateEnd: $dateEnd
      exportType: $exportType
      exportFormat: $exportFormat
      orderBy: $orderBy
      exportOption: $exportOption
    ) {
      ok
      exportTimeout
    }
  }
`)

export const EXPORT_ABSENCE_REPORT_PER_USER = graphql(`
  mutation ExportAbsenceReportPerUser(
    $dateStart: DateTime!
    $dateEnd: DateTime!
    $leaderGroup: ID
    $users: [ID!]!
    $exportOption: ExportOption!
    $exportFormat: ExportFormat
  ) {
    exportAbsenceReportPerUser(
      dateStart: $dateStart
      dateEnd: $dateEnd
      leaderGroup: $leaderGroup
      users: $users
      exportFormat: $exportFormat
      exportOption: $exportOption
    ) {
      ok
      exportId
    }
  }
`)

/* ACTIVITIES */
export const EXPORT_ACTIVITIES = graphql(`
  mutation ExportActivities(
    $userMail: String!
    $user: ID!
    $company: ID!
    $dateStart: String!
    $dateEnd: String!
    $exportType: String!
    $exportFormat: ExportFormat
    $exportOption: ExportOption
    $weekly: Boolean
    $vehicleId: ID
    $exportMode: ExportMode!
    $detailed: Boolean
  ) {
    exportActivities(
      userMail: $userMail
      user: $user
      company: $company
      dateStart: $dateStart
      dateEnd: $dateEnd
      exportType: $exportType
      exportFormat: $exportFormat
      exportOption: $exportOption
      weekly: $weekly
      vehicleId: $vehicleId
      exportMode: $exportMode
      detailed: $detailed
    ) {
      ok
      html
      exportTimeout
    }
  }
`)

export const EXPORT_ACTIVITIES_MASS = graphql(`
  mutation ExportActivitiesMass(
    $exportType: String!
    $exportFormat: ExportFormat!
    $user: ID!
    $users: [ID]
    $company: ID!
    $dateStart: String!
    $dateEnd: String!
    $orderBy: String
    $includeAbsences: Boolean
    $exportOption: ExportOption
    $weekly: Boolean
    $leaderGroups: [ID!]
    $detailed: Boolean
  ) {
    exportActivitiesMass(
      exportType: $exportType
      exportFormat: $exportFormat
      user: $user
      users: $users
      company: $company
      dateStart: $dateStart
      dateEnd: $dateEnd
      orderBy: $orderBy
      includeAbsences: $includeAbsences
      exportOption: $exportOption
      weekly: $weekly
      leaderGroups: $leaderGroups
      detailed: $detailed
    ) {
      ok
      html
      exportTimeout
    }
  }
`)

export const EXPORT_UNKNOWN_LOCATIONS = graphql(`
  mutation ExportUnknownLocations(
    $user: ID!
    $dateStart: String!
    $dateEnd: String!
  ) {
    exportUnknownLocations(
      user: $user
      dateStart: $dateStart
      dateEnd: $dateEnd
    ) {
      ok
      html
    }
  }
`)

export const EXPORT_OUT_OF_SCOPE_DRIVING = graphql(`
  mutation ExportOutOfScopeDriving(
    $user: ID!
    $dateStart: String!
    $dateEnd: String!
  ) {
    exportOutOfScopeDriving(
      user: $user
      dateStart: $dateStart
      dateEnd: $dateEnd
    ) {
      ok
      html
    }
  }
`)

export const EXPORT_START_STOP_COUNTRY_REGISTRATIONS = graphql(`
  mutation ExportStartStopCountryRegistrations(
    $user: ID!
    $dateStart: String!
    $dateEnd: String!
  ) {
    exportStartStopCountryRegistrations(
      user: $user
      dateStart: $dateStart
      dateEnd: $dateEnd
    ) {
      ok
      html
    }
  }
`)

/* ISSUES */
export const EXPORT_ISSUE = graphql(`
  mutation ExportIssue(
    $userId: ID!
    $reportId: ID!
    $recipients: [String]
    $exportType: String!
    $exportFormat: ExportFormat
    $exportOption: ExportOption
    $customExportText: String
  ) {
    exportIssue(
      userId: $userId
      reportId: $reportId
      recipients: $recipients
      exportType: $exportType
      exportFormat: $exportFormat
      exportOption: $exportOption
      customExportText: $customExportText
    ) {
      ok
      exportTimeout
    }
  }
`)

export const EXPORT_ISSUES_MASS = graphql(`
  mutation ExportIssueMass(
    $userId: ID!
    $companyId: ID!
    $recipients: [String]
    $dateStart: String!
    $dateEnd: String!
    $exportType: String!
    $exportFormat: ExportFormat
    $exportOption: ExportOption
    $includeArchived: Boolean
  ) {
    exportIssuesMass(
      userId: $userId
      companyId: $companyId
      dateStart: $dateStart
      dateEnd: $dateEnd
      recipients: $recipients
      exportType: $exportType
      exportFormat: $exportFormat
      exportOption: $exportOption
      includeArchived: $includeArchived
    ) {
      ok
      exportTimeout
    }
  }
`)

/* TIMESHEETS */
export const EXPORT_TIMESHEETS = graphql(`
  mutation ExportTimesheets(
    $userMail: String!
    $user: ID!
    $company: ID!
    $dateStart: String!
    $dateEnd: String!
    $exportType: String!
    $exportFormat: ExportFormat
    $exportOption: ExportOption
    $project: ID
  ) {
    exportTimesheets(
      userMail: $userMail
      user: $user
      company: $company
      dateStart: $dateStart
      dateEnd: $dateEnd
      exportType: $exportType
      exportFormat: $exportFormat
      exportOption: $exportOption
      project: $project
    ) {
      ok
      html
      exportTimeout
    }
  }
`)

export const EXPORT_TIMESHEETS_MASS = graphql(`
  mutation ExportTimesheetsMass(
    $userMail: String!
    $user: ID!
    $users: [ID]
    $company: ID!
    $dateStart: String!
    $dateEnd: String!
    $exportType: String!
    $exportFormat: ExportFormat!
    $orderBy: String
    $includeAbsences: Boolean
    $exportOption: ExportOption
    $project: ID
  ) {
    exportTimesheetsMass(
      userMail: $userMail
      user: $user
      users: $users
      company: $company
      dateStart: $dateStart
      dateEnd: $dateEnd
      exportType: $exportType
      exportFormat: $exportFormat
      orderBy: $orderBy
      includeAbsences: $includeAbsences
      exportOption: $exportOption
      project: $project
    ) {
      ok
      html
      exportTimeout
    }
  }
`)

/* INFRINGEMENTS */

export const EXPORT_INFRINGEMENT = graphql(`
  mutation ExportInfringement(
    $infringementId: ID!
    $exportOption: ExportOption
    $recipientId: ID
    $recipientEmails: [String]
  ) {
    exportInfringement(
      infringementId: $infringementId
      exportOption: $exportOption
      recipientId: $recipientId
      recipientEmails: $recipientEmails
    ) {
      ok
      exportTimeout
    }
  }
`)

export const EXPORT_INFRINGEMENTS = graphql(`
  mutation ExportInfringements(
    $userMail: ID!
    $user: ID!
    $dateStart: DateTime
    $dateEnd: DateTime
    $exportOption: ExportOption
  ) {
    exportInfringements(
      userMail: $userMail
      user: $user
      dateStart: $dateStart
      dateEnd: $dateEnd
      exportOption: $exportOption
    ) {
      ok
      exportTimeout
    }
  }
`)

export const EXPORT_INFRINGEMENTS_MASS = graphql(`
  mutation ExportInfringementsMass(
    $userMail: ID!
    $dateStart: DateTime
    $dateEnd: DateTime
    $exportOption: ExportOption
    $exportFormat: ExportFormat
  ) {
    exportInfringementsMass(
      userMail: $userMail
      dateStart: $dateStart
      dateEnd: $dateEnd
      exportOption: $exportOption
      exportFormat: $exportFormat
    ) {
      ok
      exportTimeout
    }
  }
`)

export const EXPORT_INFRINGEMENTS_USER_TOTALS = graphql(`
  mutation ExportInfringementsUserTotals(
    $userMail: ID!
    $dateStart: DateTime!
    $dateEnd: DateTime!
    $exportOption: ExportOption
  ) {
    exportInfringementsUserTotals(
      userMail: $userMail
      dateStart: $dateStart
      dateEnd: $dateEnd
      exportOption: $exportOption
    ) {
      ok
      exportTimeout
    }
  }
`)

export const EXPORT_DRIVER_GRADES = graphql(`
  mutation ExportDriverGrades(
    $userMail: ID!
    $dateStart: DateTime!
    $dateEnd: DateTime!
    $exportOption: ExportOption!
    $exportFormat: ExportFormat
    $sources: [DriverGradeSourceEnum]
    $sortBy: DriverGradeSortByEnum
  ) {
    exportDriverGrades(
      userMail: $userMail
      dateStart: $dateStart
      dateEnd: $dateEnd
      exportOption: $exportOption
      exportFormat: $exportFormat
      sources: $sources
      sortBy: $sortBy
    ) {
      ok
      exportTimeout
    }
  }
`)

/* FLEET — tax zone / country time report (superuser only) */

export const GENERATE_TAX_ZONE_REPORT = graphql(`
  mutation GenerateTaxZoneReport(
    $reportType: TaxZoneReportType!
    $startDate: String!
    $endDate: String!
    $userIds: [ID]
  ) {
    generateTaxZoneReport(
      reportType: $reportType
      startDate: $startDate
      endDate: $endDate
      userIds: $userIds
    ) {
      success
    }
  }
`)
